
const BASE_URL = "https://daping.sxdamo.com/";

const BASE_URL_Category = {
  padLogin: BASE_URL + "api/login/passwordLogin",  // 登录接口
  homeLaomList: BASE_URL + "api/mold/returnRate",  // 物品归还率
  moldStics: BASE_URL + "api/mold/durationStatistics",  // 使用时长统计
  moldPromlist: BASE_URL + "api/mold/alarmPromptList",  // 槽位报警提醒
  slotStatus: BASE_URL + "api/mold/slotRatioStatus",  // 槽位占比状态
  usageTics: BASE_URL + "api/mold/usageStatistics",  // 槽位使用统计
  recordList: BASE_URL + "api/mold/recordList",  // 使用记录列表
  usCateList: BASE_URL + "api/mold/userCateList",  // 用户分组列表
  moldBinList: BASE_URL + "api/mold/cabinetList",  // 大屏数据列表
  molConfdig: BASE_URL + "api/mold/config",  // shuju
  alarmList: BASE_URL + "api/mold/alarmList",  // shuju
  toreData: BASE_URL + "api/mold/allList",  // 接口文档的
  getAcctoken: BASE_URL + "api/mold/getAccessToken",  // 接口文档的
};

export default {
  BASE_URL_Category
};
